/** К-ть слотів категорійної палітри (= --cat-0..9 у globals.css). */
export const CATEGORY_PALETTE_SIZE = 10;

/**
 * Детермінований слот категорійної палітри для майстра.
 * @param id       master_id (UUID v7) — хешується канонічна lowercase-форма
 * @param override опц. ручний слот 0..N-1 (improvement-078). Валідний → повертається як є;
 *                 інакше — hash.
 * @returns слот 0..CATEGORY_PALETTE_SIZE-1 → застосовується як `data-cat`
 */
export function masterColor(id: string, override?: number | null): number {
  if (
    override != null &&
    Number.isInteger(override) &&
    override >= 0 &&
    override < CATEGORY_PALETTE_SIZE
  ) {
    return override;
  }
  return fnv1a(id.trim().toLowerCase()) % CATEGORY_PALETTE_SIZE;
}

/** FNV-1a 32-bit, стабільний між сесіями (Math.imul = 32-bit overflow). */
function fnv1a(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
